module.exports = __webpack_public_path__ + "img/home-banner.0ac9e071.png";